<template>
  <div class="page-container">
    <div class="page-header">
      <HeaderCom></HeaderCom>
    </div>
    <div class="scene-main">
      <div class="generation-wrap">
        <div class="left-content">
          <div class="data-location" id="DataLocation">
            <div class="title">
              <div class="text">
                云图雅集
              </div>
              <div class="subText">
                CLOUD GRACE COLLECTED
              </div>
            </div>
            <transition
              appear
              appear-to-class="animate__animated animate__fadeIn"
            >
              <div class="content" v-if="teaTemplateFilter.length > 0">
                <div
                  class="item"
                  :class="{ active: item.product.product_id === productId }"
                  v-for="(item, index) in teaTemplateFilter"
                  :key="index"
                  @click="selectProduct(item)"
                >
                  <img :src="item.main" alt="" width="100%" height="100%" />
                  <img class="icon" src="@/assets/image/dagou.png" alt="" />
                </div>
              </div>
              <div class="content" v-else>
                <el-empty description="暂无编辑的产品"></el-empty>
              </div>
            </transition>
            <div class="foot">
              <div class="submit-btnn">
                <button @click="putaway" class="left" id="putawayBtn">
                  <div class="text">
                    上架商品
                  </div>
                  <div class="subText">
                    Merchandise on the shelves
                  </div>
                </button>
                <button class="right" @click="toNextRouter">
                  <div class="text">
                    下一步
                  </div>
                  <div class="subText">
                    Merchandise on the shelves
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <Shopee ref="shopee"></Shopee>
        </div>
        <stepDialog
          v-if="stepDialogStatus.show"
          :status="stepDialogStatus"
          @close="close"
        ></stepDialog>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "@/components/headerCom";
import Shopee from "./shopee";
import stepDialog from "@/components/stepDialog";
export default {
  components: {
    Shopee,
    stepDialog,
    HeaderCom,
  },
  data() {
    return {
      teaTemplate: [
        {
          product: {
            product_id: "",
          },
        },
      ],
      productId: "",
      DriverInstance: null,
      stepDialogStatus: {
        show: false,
        in: false,
        start: 9,
        end: 10,
        page: "putaway",
      },
    };
  },
  computed: {
    teaTemplateFilter() {
      let $tea = this.teaTemplate.filter((item) => {
        return item.product;
      });
      return $tea;
    },
  },
  watch: {
    "stepDialogStatus.show": function(newv) {
      if (newv) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "initial";
      }
    },
  },
  created() {
    this.$axios
      .post("/student/data/present/upload/template", {
        expId: this.$route.query.id,
      })
      .then((res) => {
        if (res.succeed) {
          this.teaTemplate = res.items;
        }
      });
  },
  mounted() {
    // this.stepStart()
  },
  beforeRouteLeave(to, from, next) {
    if (this.DriverInstance) {
      this.DriverInstance.reset();
    }
    next();
  },
  methods: {
    close() {
      this.stepDialogStatus.in = false;
      setTimeout(() => {
        this.stepDialogStatus.show = false;
      }, 1000);
    },
    stepStart() {
      if (!localStorage.getItem("Putaway1")) {
        this.DriverInstance = this.Driver("Putaway1");
        setTimeout(() => {
          this.DriverInstance.start();
        }, 2000);
      }
    },
    toNextRouter() {
      this.$router.push({
        path: "/customerService",
        query: this.$route.query,
      });
    },
    selectProduct(item) {
      this.productId =
        item.product.product_id === this.productId
          ? ""
          : item.product.product_id;
    },
    putaway() {
      this.$axios
        .post("/student/data/present/online/product", {
          productId: this.productId,
          type: true,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.$refs["shopee"].getList();
          } else {
            this.$message({
              message: res.message,
              type: "error",
              customClass: "customClass",
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding-bottom: 0;
  margin-bottom: 10px;
  .text {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  .subText {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100vw;
  min-height: 100vh;
  background: url("./../../assets/image/simulation/bg.jpg");
  background-size: cover;
  padding-top: 60px;
  .page-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 60px;
    background: #005be7;
  }
  .scene-main {
    width: calc(100% - 280px);
  }
}

.generation-wrap {
  display: flex;

  .left-content {
    width: 400px;
    height: 722px;
    margin-right: 40px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 12px;

    .data-location {
      width: 100%;
      height: 100%;
      padding: 30px;
      display: flex;
      flex-direction: column;
      box-shadow: 0 0 4px #cacaca;
      border-radius: 10px;

      .title {
        @include title;
        margin-bottom: 24px;
      }

      .content {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .has {
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          overflow-y: auto;
        }

        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 160px;
          height: 160px;
          text-align: center;
          margin-right: 20px;
          background: #ffffff;
          border: 1px solid #f1f1f1;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 16px;
          position: relative;
          cursor: pointer;

          &:nth-child(even) {
            margin-right: 0;
          }

          .icon {
            width: 0;
            height: 0;
            position: absolute;
            bottom: 6px;
            right: 6px;
            z-index: -1;
            transition: all 0.3s linear;
          }

          &:hover {
            box-shadow: 0 0 10px #cacaca;
          }

          &.active .icon {
            width: 30px;
            height: 30px;
            z-index: 9;
            transition: all 0.3s linear;
          }
        }
      }

      .foot {
        .submit-btnn {
          button {
            width: 50%;
            height: 64px;
            background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
            opacity: 1;
            border-radius: 60px;

            &.left {
              border-radius: 60px 0 0 60px;
            }

            &.right {
              border-radius: 0 60px 60px 0;
            }

            .text {
              font-size: 22px;
              font-family: Microsoft YaHei UI;
              font-weight: 400;
              line-height: 26px;
              color: #ffffff;
            }

            .subText {
              font-size: 10px;
              font-weight: 400;
              line-height: 14px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .right-content {
    flex-grow: 1;
    flex-shrink: 1;
    height: 722px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
